// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChevronLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15">
            <polygon
                fill="currentColor"
                points="1.551 0 2.148 .752 7.041 6.921 7.5 7.5 7.041 8.079 1.551 15 0 13.843 .597 13.09 5.03 7.5 .597 1.91 0 1.157"
                transform="matrix(-1 0 0 1 7.5 0)"
            />
        </svg>
    );
};

export default React.memo(ChevronLeft);
